import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {WidgetModule} from '../../layout/widget/widget.module';
import {CaseAvatarModule} from '../../components/case-avatar/case-avatar.module';
import {DashboardComponent} from './dashboard/dashboard.component';
import {FormsModule} from '@angular/forms';
import {ModalModule} from 'ngx-bootstrap';
import {NKDatetimeModule} from 'ng2-datetime';
import {ValidationModule} from '../../components/validation/validation.module';
import {HistoryComponent} from './history/history.component';
import {SachetsOrganizationsComponent} from './sachets-organizations/sachets-organizations.component';

export const routes = [
    {path: '', redirectTo: 'sachet-management', pathMatch: 'full'},
    {path: 'dashboard', component: DashboardComponent},
    {path: 'history', component: HistoryComponent},
    {path: 'sachets-organizations', component: SachetsOrganizationsComponent},
];


@NgModule({
    declarations: [DashboardComponent, HistoryComponent, SachetsOrganizationsComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FontAwesomeModule,
        WidgetModule,
        CaseAvatarModule,
        FormsModule,
        ModalModule,
        NKDatetimeModule,
        ValidationModule,
    ], exports: [DashboardComponent]
})
export class SachetsManagementModule {
    static routes = routes;
}
